export default {
  loginHeader: "Suswagatam fir se",
};
